import { useContext } from "react";
import SessionContext from "../contexts/SessionContext/SessionContext";

function useSession() {
  return useContext(SessionContext);
}

export default useSession;
